import React from 'react'
import Hero from '../../components/Service/Servicesub/ecommercestore/Hero'
import Description from '../../components/Service/Servicesub/ecommercestore/Description'
import Technologies from '../../components/Service/Servicesub/ecommercestore/Technologies'
import Number from '../../components/Service/Servicesub/ecommercestore/Number'
const Ecommerce = () => {
  return (
    <div>
     <Hero />
            <Description />
            <Technologies />
            <Number />
    </div>
  )
}

export default Ecommerce
